<app-gallery-settings-customize-header
  title="Cover"
  location="theme-cover-customize"
  (back)="back.emit()"
></app-gallery-settings-customize-header>

<app-gallery-settings-group title="Design">
  <app-theme-cover-select-item [gallery]="gallery()"></app-theme-cover-select-item>
</app-gallery-settings-group>

@if (theme().cover.design) {
  <app-gallery-settings-group class="hiding-group" title="Options" [@optionsGroup]>
    <app-theme-cover-height-item [gallery]="gallery()"></app-theme-cover-height-item>
    <app-theme-cover-text-position-item [gallery]="gallery()"></app-theme-cover-text-position-item>
    <app-theme-cover-overlay-color-item [gallery]="gallery()"></app-theme-cover-overlay-color-item>
  </app-gallery-settings-group>
}

<app-gallery-settings-group title="Text">
  <div class="togglers">
    <app-theme-cover-title-item
      [gallery]="gallery()"
      [theme]="theme()"
      [open]="openToggler() === 'coverTitle'"
      (onOpen)="openToggler.set('coverTitle')"
      (onClose)="openToggler.set(undefined)"
    ></app-theme-cover-title-item>
    <app-theme-cover-description-item
      [gallery]="gallery()"
      [theme]="theme()"
      [open]="openToggler() === 'coverDescription'"
      (onOpen)="openToggler.set('coverDescription')"
      (onClose)="openToggler.set(undefined)"
    ></app-theme-cover-description-item>
  </div>
</app-gallery-settings-group>
